import { convertLexicalToPlaintext } from '@payloadcms/richtext-lexical/plaintext'
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'

export function hasRichText(data: unknown): boolean {
  if (!data || typeof data !== 'object' || !('root' in (data as object))) return false

  try {
    return convertLexicalToPlaintext({ data: data as SerializedEditorState }).trim().length > 0
  } catch {
    return false
  }
}
